// extracted by mini-css-extract-plugin
export default {"wrap":"Tooltip_wrap__dS2SZ","tooltip":"Tooltip_tooltip__7Ul0z","multiline":"Tooltip_multiline__o6vGa"};